import { axiosInstance } from '../../utils';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  paypalId: string;
}

const setUserPaymentAccount = async ({ paypalId }: Payload): Promise<any> => {
  const res = await axiosInstance.post(`/api/payout/account-details`, { paypalId });
  return res.data;
};

export function useSetUserPaymentAccount() {
  return useMutation(setUserPaymentAccount, { onSuccess: (data) => data });
}
